import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import OverviewProfileBasicDetailsSkeleton from 'components/shared/skeletons/OverviewProfileBasicDetailsSkeleton';
import UserAvatar from 'components/shared/user/UserAvatar';
import UserInfo from 'components/shared/user/UserInfo';
import ImageViewModal from 'components/shared/modals/ImageViewModal';
import StyledOverviewProfileDetailsContainer from 'common/theme/overview-profile/StyledOverviewProfileDetailsContainer';

function OverviewProfileBasicDetails({ user = null, loading }) {
  const [viewerOpen, setViewerOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const avatarSize = isDesktop ? 200 : 120;
  const hasPhoto = Boolean(user?.photo);

  return (
    <StyledOverviewProfileDetailsContainer>
      {loading ? (
        <OverviewProfileBasicDetailsSkeleton />
      ) : (
        <>
          {/* La foto es clickeable: abre el visor (como en el perfil). */}
          <Box
            role={hasPhoto ? 'button' : undefined}
            tabIndex={hasPhoto ? 0 : undefined}
            onClick={hasPhoto ? () => setViewerOpen(true) : undefined}
            onKeyDown={hasPhoto ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setViewerOpen(true); } } : undefined}
            sx={{ cursor: hasPhoto ? 'pointer' : 'default', borderRadius: '50%', transition: 'transform 0.2s', '&:hover': hasPhoto ? { transform: 'scale(1.02)' } : undefined }}
          >
            <UserAvatar size={avatarSize} user={user} />
          </Box>
          <UserInfo
            age={user.age}
            country={user.country}
            fullName={user.full_name}
            gender={user.gender}
            membershipStatus={user?.membership_status}
          />
          <ImageViewModal open={viewerOpen} src={user?.photo} alt={user?.full_name} onClose={() => setViewerOpen(false)} />
        </>
      )}
    </StyledOverviewProfileDetailsContainer>
  );
}

OverviewProfileBasicDetails.propTypes = {
  user: PropTypes.object,
  loading: PropTypes.bool.isRequired
};

export default OverviewProfileBasicDetails;
